import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import styles from './index.module.scss.js';

/**
 * Converts a number value to pixels string, or returns the original string value
 * @param value - The value to convert (string | number)
 * @returns The sanitized CSS value
 */
const toCssValue = (value) => {
    return typeof value === 'number' ? `${value}px` : value;
};
const LoadingSkeleton = ({ width, height, borderRadius, aspectRatio, className, style = {}, ariaLabel, themed, }) => {
    const skeletonStyle = {
        width: toCssValue(width),
        height: toCssValue(height),
        borderRadius: toCssValue(borderRadius),
        aspectRatio,
        ...style,
    };
    return (jsx("div", { className: classnames(styles.skeleton, className, {
            [styles.themed]: themed,
        }), style: skeletonStyle, "aria-label": ariaLabel, role: "alert", "aria-busy": "true", "aria-live": "polite" }));
};

export { LoadingSkeleton };
//# sourceMappingURL=index.js.map
